var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rph-header__buttons"},[(!_vm.collapse)?_c('RPHHeaderWhatsApp'):_vm._e(),_vm._v(" "),(!_vm.collapse)?_c('RPHHeaderBonus'):_vm._e(),_vm._v(" "),_c('RPHHeaderProfileControl'),_vm._v(" "),_c('RPHHeaderBasket')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }